import { endPoints } from "@/constants";
import * as apiService from "./apiService";

export async function getMatches(requestPayload) {
  return await apiService.apiCall(endPoints.GET_MATCHES, "GET", requestPayload);
}
